import { MFA_AUTH_ENABLE } from '@organization/app-constants'
import { paths } from '@organization/router'
import { useSessionContext } from '@shared/hooks'
import { Tabs } from 'antd'
import { useTranslation } from 'react-i18next'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

export const LogsPage = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const { isAdmin } = useSessionContext()

  const items = [
    ...(isAdmin
      ? [
          {
            label: t('menu.logs_applications'),
            key: paths.logs.applications,
            children: <Outlet />
          }
        ]
      : []),
    ...(MFA_AUTH_ENABLE
      ? [
          {
            label: t('menu.logs_mfa'),
            key: paths.logs.mfa,
            children: <Outlet />
          }
        ]
      : [])
  ]

  return (
    <Tabs
      defaultActiveKey={location.pathname}
      onTabClick={(value) => navigate(value)}
      items={items}
    />
  )
}
